module.exports = __webpack_public_path__ + "img/PickupNotMonitored.4a2d172c.svg";